const STANDARD_USER = 'Standard user'
const FULL_USER = 'Full user'

const STANDARD_ROLE = 'Standard'
const FINANCE_ROLE = 'Finance'
const ADMIN_ROLE = 'Account owner'
const PROJECT_MANAGER_ROLE = 'Project Management'

const RODEO_SUPPORT_EMAIL = 'support@getrodeo.io'
const RODEO_URL = 'https://app.getrodeo.io'

const USER_ROLES = [FINANCE_ROLE, PROJECT_MANAGER_ROLE, ADMIN_ROLE]

const USER_STATUS_ARCHIVED = 'archived'
const USER_STATUS_ACTIVE = 'active'
const USER_STATUS_INVITED = 'invited'

const XERO_LOGIN_URL = '/xero/login'

export {
  STANDARD_USER,
  FULL_USER,
  STANDARD_ROLE,
  FINANCE_ROLE,
  ADMIN_ROLE,
  PROJECT_MANAGER_ROLE,
  RODEO_SUPPORT_EMAIL,
  USER_ROLES,
  RODEO_URL,
  USER_STATUS_ARCHIVED,
  USER_STATUS_ACTIVE,
  USER_STATUS_INVITED,
  XERO_LOGIN_URL
}
